import Document from '../components/Document';

function Footer() {
  return (
      <div className="vertical-content">
        <div>
          <h2>DOCUMENTOS DE CONSULTA</h2>
          <hr className="red" style={{ margin: '10px 0 30px' }}></hr>
        </div>

        <div className='horizontal-content top-content cards-container'>
            <Document text='Guía para la implementación de la NOM-005-SEDATU-2024'
            image='Foto_NOM' key='documCard1' buttonText='CONSULTAR'></Document>
            <Document text='Curso para la implementación de la NOM-005-SEDATU-2024'
            image='Curso_NOM' key='documCard2' buttonText='VISITAR'></Document>
            <Document text='Infografías sobre la NOM-005-SEDATU-2024'
            image='Infografías_NOM' key='documCard3' buttonText='CONSULTAR'></Document>
            <Document text='Publicación oficial de la NOM-005-SEDATU-2024'
            image='Foto_NOM' key='documCard4' buttonText='VISITAR'
            urlLink='https://dof.gob.mx/nota_detalle.php?codigo=5732738&fecha=09/07/2024#gsc.tab=0'></Document>
        </div>
      </div>
  );
}

export default Footer;
